import { render, staticRenderFns } from "./SkeletonOneCard.vue?vue&type=template&id=cc0343ca&scoped=true"
import script from "./SkeletonOneCard.vue?vue&type=script&lang=js"
export * from "./SkeletonOneCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0343ca",
  null
  
)

export default component.exports